module.exports = __webpack_public_path__ + "static/media/logo-dinamis.6a9aae60.png";